import { Folder } from '../server/folder';

export class AttributesSectionRefreshEvent {
    public constructor(public folder: Folder) {}
}
